var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-modal-setting',{attrs:{"title":"Label","value":_vm.value,"placeholder":"None"}},[_c('core-input-textbox',{attrs:{"autofocus":true,"maxlength":"16","placeholder":"Enter label"},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }